interface Rights {
	highlightText: string;
	info: string;
}

export interface ConsumerRightsByStateI {
	state: string;
	rights: Rights[];
	effectiveDate?: string;
}

export const consumerRightsByState: ConsumerRightsByStateI[] = [
	{
		state: 'Alabama',
		effectiveDate: '(effective May 1, 2027)',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and to access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain a copy of their personal data that the consumer previously provided to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data, or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'California',
		rights: [
			{
				highlightText: 'Know.',
				info: 'Consumers have the right to know what personal information the business has collected about the consumer, including the categories of personal information it has collected about that consumer; the categories of sources from which the personal information is collected; the business or commercial purposes for collecting, selling, or sharing personal information; the categories of third parties to whom the business discloses personal information; and the specific pieces of personal information it has collected about that consumer. Furthermore, consumers have the right to request that a business that sells or shares the consumer\u2019s personal information, or that discloses it for a business purpose, disclose to that consumer: the categories of personal information that the business collected about the consumer; the categories of personal information that the business sold or shared about the consumer and the categories of third parties to whom the personal information was sold or shared, by category or categories of personal information for each category of third parties to whom the personal information was sold or shared; and the categories of personal information that the business disclosed about the consumer for a business purpose and the categories of persons to whom it was disclosed for a business purpose.',
			},
			{
				highlightText: 'Data Portability.',
				info: 'As part of the right to know, consumers have the right to request a copy of the specific pieces of personal information the business has collected about them in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the information to another entity without hindrance.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal information that the business has collected from the consumer.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccurate personal information that a business maintains about a consumer, taking into account the nature of the personal information and the purposes of the processing of the personal information.',
			},
			{
				highlightText: 'Opt-Out of Sale or Sharing.',
				info: 'Consumers have the right, at any time, to direct a business that sells or shares personal information about the consumer to third parties not to sell or share the consumer\u2019s personal information. Note that sharing refers specifically to sharing for cross-context behavioral advertising, which is the targeting of advertising to a consumer based on the consumer\u2019s personal information obtained from the consumer\u2019s online activity across numerous websites.',
			},
			{
				highlightText: 'Limit the Use of Your Sensitive Personal Information.',
				info: 'If the business uses or discloses sensitive personal information for reasons other than those set forth in CPRA, consumers have the right to limit the use or disclosure of sensitive personal information by the business.',
			},
			{
				highlightText: 'No Retaliation.',
				info: 'Consumers have the right not to receive discriminatory treatment for the exercise of your privacy rights conferred by the CCPA.',
			},
		],
	},
	{
		state: 'Colorado',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such actions would reveal a trade secret. This includes personal data maintained about consumers we generated from other data, or obtained from others, directly or through its processors, including final profiling decisions, inferences, derivative data, marketing profiles, and other personal data.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data (with some limitation).',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data collected from or about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain a portable copy of their personal data to the extent technically feasible and provided the controller will not be required to reveal any trade secret.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Connecticut',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such actions would reveal a trade secret.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data (with some limitation).',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain a portable copy of their personal data to the extent technically feasible and provided the controller will not be required to reveal any trade secret.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Delaware',
		rights: [
			{
				highlightText: 'Know.',
				info: 'Consumers have the right to obtain a list of the categories of third parties to which the controller has disclosed the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such actions would reveal a trade secret.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain a portable copy of their personal data to the extent technically feasible and provided the controller will not be required to reveal any trade secret.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Florida',
		rights: [
			{
				highlightText: 'Know.',
				info: "Consumers have the right to obtain a list of the categories of third parties to which the controller has disclosed the consumer's personal data.",
			},
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete any or all personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain a portable copy of their personal data to the extent technically feasible and provided the controller will not be required to reveal any trade secret.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising; (ii) the sale of personal data, (iii) profiling in furtherance of a decision that produces a legal or similarly significant effect concerning a consumer; (iv) collection or processing sensitive data (including precise geolocation data); and (v) collection of personal data collected through the operation of a voice recognition or facial recognition feature.',
			},
		],
	},
	{
		state: 'Indiana',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data (with some limitation).',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data. Upon receiving a request from a consumer under this subdivision, a controller shall correct inaccurate information as requested by the consumer, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain either (i) a copy of or (ii) a representative summary of the consumer's personal data that the consumer previously provided to the controller, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data. A controller is not required to provide a copy or a representative summary of a consumer's personal data to the same consumer under this subdivision more than one time in a twelve month period.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Iowa',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data (with some limitations) that the consumer previously provided to the controller in a portable and, to the extent technically practicable, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the sale of personal data.',
			},
		],
	},
	{
		state: 'Kentucky',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such actions would reveal a trade secret.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data that the consumer previously provided to the controller in a portable and, to the extent technically practicable, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means. The controller shall not be required to reveal any trade secrets.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Maryland',
		rights: [
			{
				highlightText: 'Know.',
				info: 'Consumers have the right to obtain a list of the categories of third parties to which the controller has disclosed the consumer\u2019s personal data or a list of the categories of third parties to which the controller has disclosed any consumer\u2019s personal data if the controller does not maintain this information in a format specific to the consumer.',
			},
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or about the consumer, unless the retention is required by law.',
			},
			{
				highlightText: 'Data portability.',
				info: 'If the processing of personal data is done by automatic means, consumers have the right to obtain a copy of the consumer\u2019s personal data processed by the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to easily transmit the data to another controller without hindrance.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Minnesota',
		rights: [
			{
				highlightText: 'Know.',
				info: "Consumers have a right to obtain a list of the specific third parties to which the controller has disclosed the consumer's personal data. If the controller does not maintain the information in a format specific to the consumer, a list of specific third parties to whom the controller has disclosed any consumers' personal data may be provided instead.",
			},
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing personal data concerning the consumer and access the categories of personal data the controller is processing.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data concerning the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to obtain personal data concerning the consumer, which the consumer previously provided to the controller, in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means.',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of automated decisions that produce legal effects concerning a consumer or similarly significant effects concerning a consumer.',
			},
			{
				highlightText: 'Question.',
				info: "If a consumer's personal data is profiled in furtherance of decisions that produce legal effects concerning a consumer or similarly significant effects concerning a consumer, the consumer has the right to question the result of the profiling, to be informed of the reason that the profiling resulted in the decision, and, if feasible, to be informed of what actions the consumer might have taken to secure a different decision and the actions that the consumer might take to secure a different decision in the future.",
			},
			{
				highlightText: 'Review.',
				info: "Consumers have the right to review the consumer's personal data used in the profiling. If the decision is determined to have been based upon inaccurate personal data, taking into account the nature of the personal data and the purposes of the processing of the personal data, the consumer has the right to have the data corrected and the profiling decision reevaluated based upon the corrected data.",
			},
		],
	},
	{
		state: 'Montana',
		rights: [
			{
				highlightText: 'Access.',
				info: "Consumers have the right to confirm whether a controller is processing the consumer's personal data and access the consumer's personal data, unless such confirmation or access would require the controller to reveal a trade secret.",
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in their personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer\u2019s personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data previously provided by the consumer to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the personal data to another controller without hindrance when the processing is carried out by automated means, provided the controller is not required to reveal any trade secret.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data (with some limitations) or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Nebraska',
		rights: [
			{
				highlightText: 'Access.',
				info: "Consumers have the right to confirm whether a controller is processing the consumer's personal data and to access the personal data.",
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "If the data is available in a digital format and the processing is completed by automated means, obtain a copy of the consumer's personal data that the consumer previously provided to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of a decision that produces a legal or similarly significant effect concerning the consumer.',
			},
		],
	},
	{
		state: 'Nevada',
		rights: [
			{
				highlightText: 'Opt-Out of Sale.',
				info: 'Consumers have the right to direct us not to make any sale of covered information that we have collected or will collect about them. Under Nevada law, a "sale" means the exchange of covered information for monetary consideration to a person for that person to license or sell the information to additional persons. To submit a request, email support@claimmagic.com. We will respond within 60 days, with a possible 30-day extension where reasonably necessary.',
			},
			{
				highlightText: 'Consumer Health Data \u2014 Confirm and Access.',
				info: 'Consumers have the right to confirm whether we are collecting, sharing, or selling their consumer health data and to access such data, including a list of the third parties with whom it has been shared or sold.',
			},
			{
				highlightText: 'Consumer Health Data \u2014 Deletion.',
				info: 'Consumers have the right to request deletion of their consumer health data.',
			},
			{
				highlightText: 'Consumer Health Data \u2014 Consent and Authorization.',
				info: "We obtain consent before collecting or sharing consumer health data beyond what is necessary to provide a product or service the consumer has requested, and we will not sell consumer health data without first obtaining the consumer's affirmative, written authorization meeting the requirements of Nevada law.",
			},
		],
	},
	{
		state: 'New Hampshire',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such confirmation or access would require the controller to reveal a trade secret.',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data processed by the controller, in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means, provided such controller shall not be required to reveal any trade secret.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data (with some limitations) or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'New Jersey',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such confirmation or access would require the controller to reveal a trade secret.',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data concerning the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data previously provided by the consumer to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the personal data to another controller without hindrance when the processing is carried out by automated means, provided such controller shall not be required to reveal any trade secret.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Oklahoma',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in personal data about the consumer, taking into account the nature of the personal data and the controller's purpose for processing the personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data previously provided by the consumer to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the personal data to another controller without hindrance when the processing is carried out by automated means, provided such controller shall not be required to reveal any trade secret.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data, or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Oregon',
		rights: [
			{
				highlightText: 'Know.',
				info: 'At the controller\u2019s option, consumers can ask for a list of specific third parties, other than natural persons, to which the controller has disclosed: (i) the consumer\u2019s personal data; or (ii) any personal data.',
			},
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether the controller is processing or has processed the consumer\u2019s personal data and the categories of personal data the controller is processing or has processed.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in personal data about the consumer, taking into account the nature of the personal data and the controller\u2019s purpose for processing the personal data.',
			},
			{
				highlightText: 'Data portability.',
				info: 'Consumers have the right to copy of all of the consumer\u2019s personal data that the controller has processed or is processing.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data about the consumer, including personal data the consumer provided to the controller, personal data the controller obtained from another source and derived data; or',
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of decisions that produce legal effects or effects of similar significance.',
			},
		],
	},
	{
		state: 'Rhode Island',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data, unless such confirmation or access would require the controller to reveal a trade secret.',
			},
			{
				highlightText: 'Correction & Deletion.',
				info: "Correct inaccuracies in the customer's personal data and delete personal data provided by, or obtained about, the customer, taking into account the nature of the personal data and the purposes of the processing of the customer's personal data.",
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the customer's personal data processed by the controller, in a portable and, to the extent technically feasible, readily usable format that allows the customer to transmit the data to another controller without undue delay, where the processing is carried out by automated means; provided such controller shall not be required to reveal any trade secret.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of solely automated decisions that produce legal or similarly significant effects concerning the customer.',
			},
		],
	},
	{
		state: 'Tennessee',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal information, taking into account the nature of the personal information and the purposes of the processing of the consumer's personal information.",
			},
			{
				highlightText: 'Deletion.',
				info: "Consumers have the right to delete personal information provided by or obtained about the consumer. A controller is not required to delete information that it maintains or uses as aggregate or de-identified data; provided, that such data in the possession of the controller is not linked to a specific consumer. A controller that obtained personal information about a consumer from a source other than the consumer is in compliance with a consumer's request to delete such personal information by: (i) (a) retaining a record of the deletion request and the minimum information necessary for the purpose of ensuring that the consumer's personal information remains deleted from the controller's records; and (b) not using such retained personal information for any purpose prohibited under this part; or (ii) opting the consumer out of the processing of such personal data for any purpose except for those exempted.",
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to a copy of the consumer's personal information that the consumer previously provided to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means; or",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) selling personal information about the consumer, (ii) targeted advertising, or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Texas',
		rights: [
			{
				highlightText: 'Access.',
				info: 'Consumers have the right to confirm whether a controller is processing their personal data and access such personal data.',
			},
			{
				highlightText: 'Correction.',
				info: 'Consumers have the right to correct inaccuracies in personal data about the consumer, taking into account the nature of the personal data and the controller\u2019s purpose for processing the personal data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "If the data is available in a digital format, consumers have a right to obtain a copy of the consumer's personal data that the consumer previously provided to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance; or",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of a decision that produces a legal or similarly significant effect concerning the consumer.',
			},
		],
	},
	{
		state: 'Utah',
		effectiveDate: '(effective July 1, 2026)',
		rights: [
			{
				highlightText: 'Access.',
				info: "Consumers have the right to confirm whether a controller is processing personal data concerning the consumer and to access the consumer's personal data.",
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal information, taking into account the nature of the personal information and the purposes of the processing of the consumer's personal information.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete the personal data that the consumer provided to the controller.',
			},
			{
				highlightText: 'Data Portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data, that the consumer previously provided to the controller, in a format that to the extent technically feasible, is portable; to the extent practicable, is readily usable; and allows the consumer to transmit the data to another controller without impediment, where the processing is carried out by automated means.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising; or (ii) the sale of personal data.',
			},
		],
	},
	{
		state: 'Virginia',
		rights: [
			{
				highlightText: 'Access.',
				info: "Consumers have the right to confirm whether a controller is processing the consumer's personal data and to access such personal data.",
			},
			{
				highlightText: 'Correction.',
				info: "Consumers have the right to correct inaccuracies in the consumer's personal data, taking into account the nature of the personal data and the purposes of the processing of the consumer's personal data.",
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete personal data provided by or obtained about the consumer.',
			},
			{
				highlightText: 'Data portability.',
				info: "Consumers have the right to obtain a copy of the consumer's personal data that the consumer previously provided to the controller in a portable and, to the extent technically feasible, readily usable format that allows the consumer to transmit the data to another controller without hindrance, where the processing is carried out by automated means.",
			},
			{
				highlightText: 'Opt-out of certain data processing.',
				info: 'Consumers have the right to opt out of the processing of personal data for purposes of (i) targeted advertising, (ii) the sale of personal data or (iii) profiling in furtherance of decisions that produce legal or similarly significant effects concerning the consumer.',
			},
		],
	},
	{
		state: 'Washington',
		rights: [
			{
				highlightText: 'Confirm and Access.',
				info: 'Consumers have the right to confirm whether we are collecting, sharing, or selling their consumer health data and to access such data, including a list of all third parties and affiliates with whom we have shared or to whom we have sold the consumer health data, along with an active means of contacting those parties.',
			},
			{
				highlightText: 'Withdraw Consent.',
				info: 'Consumers have the right to withdraw consent to our collection and to our sharing of their consumer health data.',
			},
			{
				highlightText: 'Deletion.',
				info: 'Consumers have the right to delete their consumer health data. Upon a verified request, we will delete the data from our records and notify our affiliates, processors, contractors, and any third parties with whom the data was shared to delete it as well.',
			},
			{
				highlightText: 'Authorization for Sale.',
				info: "We will not sell consumer health data without first obtaining the consumer's valid, written authorization that is separate from consent and that meets the specific requirements of the MHMDA.",
			},
			{
				highlightText: 'No Geofencing.',
				info: 'We do not use a geofence to establish a virtual boundary around any entity providing in-person health care services in order to identify, track, or collect data from consumers, or to send them notifications or advertisements related to their consumer health data.',
			},
			{
				highlightText: 'No Retaliation.',
				info: 'Consumers have the right not to receive discriminatory or retaliatory treatment for exercising any right described above.',
			},
		],
	},
];
